export enum EnAtribuicaoTipo {
	Papel = 0,
	Executor = 1,
	Solicitante = 2,
	Especifico = 3,
	Conclusao = 4,
	ConclusaoPosRetornoProximoPasso = 5
}
